<template>
	<header class="header section-header" :class="header">
		<div class="container">
			<div class="row cont-pad">
				<div class="col-7 col-sm-7 col-md-6 offset-md-1">
					<div class="header-text-wrap">
						<slot></slot>
					</div>
				</div>
				<div v-if="home" class="col-5">
					<img class="header-img" src="@/assets/img/LogoWithLines.png">
					<div class="banner-anim-cont">
						<div class="red-cont">
							<img class="red-1" src="@/assets/img/red_dot.png" alt="">
							<img class="red-1-2" src="@/assets/img/red_dot.png" alt="">
							<img class="red-2" src="@/assets/img/red_dot.png" alt="">
							<img class="red-2-2" src="@/assets/img/red_dot.png" alt="">
							<img class="red-3" src="@/assets/img/red_dot.png" alt="">
							<img class="red-3-2" src="@/assets/img/red_dot.png" alt="">
							<img class="red-4" src="@/assets/img/red_dot.png" alt="">
							<img class="red-4-2" src="@/assets/img/red_dot.png" alt="">
							<img class="red-4-3" src="@/assets/img/red_dot.png" alt="">
						</div>
						<div class="blue-cont">
							<img class="blue-1" src="@/assets/img/blue_dot.png" alt="">
							<img class="blue-2" src="@/assets/img/blue_dot.png" alt="">
							<img class="blue-3" src="@/assets/img/blue_dot.png" alt="">
							<img class="blue-4" src="@/assets/img/blue_dot.png" alt="">
							<img class="blue-5" src="@/assets/img/blue_dot.png" alt="">
							<img class="blue-6" src="@/assets/img/blue_dot.png" alt="">
							<img class="blue-7" src="@/assets/img/blue_dot.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: "Header",
	props: {
		home: {
			type: Boolean,
			default: false
		},
		cat: {
			type: String,
			default: null,
		},
	},
	computed: {
		header: function() {
			return {
				solutionsHeight: this.cat != null,
				headerGaming: this.cat === "gaming",
				headerServers: this.cat === "servers",
				headerHosts: this.cat === "hosts",
				headerEnterprise: this.cat === "enterprise",
				headerLanding: this.cat == null
			}
		},
	}
}
</script>

<style scoped>
.headerLanding {
	background: rgb(20,29,40);
	background: radial-gradient(58em 43em ellipse at 65% 100%, rgb(218, 136, 14), rgb(140, 59, 41) 23%, rgba(158,68,77,50%) 35%, rgba(0,0,0,0) 50%),
				linear-gradient(175deg, rgb(20, 29, 40) 30%, rgb(6, 36, 56) 73%);
}
.solutionsHeight {
	height: 30em;
}
.header-img {
	width: 70em;
	max-width: 200em;
	position: relative;
	left: -25em;
	margin-top: 0em;
	z-index: 0;
}

@media only screen and (max-width: 576px) {
    .cont-pad {
		padding: 0 2em;
    }
}

.headerGaming {
    background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 39%, rgba(0,0,0,0) 80%, rgba(0,0,0,0.6544818611038166) 90%, rgba(0,0,0,1) 100%),
		url('~@/assets/img/categories/gaming_header.png'),
		#000;
	background-size: 1200px 650px !important;
	background-position: calc(50% + 12em) top;
}
.headerServers {
    background: url('~@/assets/img/categories/servers_header.png');
}
.headerHosts {
    background: url('~@/assets/img/categories/hosts_header.png');
}
.headerEnterprise {
    background: url('~@/assets/img/categories/enterprise_header.png');
}
.header {
    min-height: 25em;
    background-repeat: no-repeat;
	background-size: cover;
}

.header-text-wrap {
	max-width: 34em;
	min-width: 20em;
	left: 0px;
}

@media only screen and (max-width: 576px) {
	.header-text h1 {
		font-size: 36px !important;
	}
}

/* Banner connection animation */
.banner-anim-cont {
	--anim-duration: 3s;
	--img-width: 20px;
	display: flex;
	width: 200%;
	margin: calc(var(--img-width) * -6);
}
.red-cont, .blue-cont {
	position: relative;
}
.red-cont {
	width: var(--img-width);
	left: -280px;
	top: -193px;
}
.blue-cont {
	left: 360px;
	top: -115px;
}
.red-cont img, .blue-cont img {
	position: absolute;
	width: var(--img-width);
	min-width: var(--img-width);
	height: var(--img-width);
	min-height: var(--img-width);
}

.red-1, .red-1-2 {
	top: 0px;
	left: 40px;
	opacity: 0;
	animation-name: red-1;
	animation-duration: var(--anim-duration);
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-fill-mode: forwards;
}
.red-1-2 {
	animation-duration: calc(var(--anim-duration) / 1.5);
	animation-delay: calc(var(--anim-duration) / 3);
}
.red-2, .red-2-2 {
	top: 63px;
	left: 25px;
	opacity: 0;
	animation-name: red-2;
	animation-duration: var(--anim-duration);
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-fill-mode: forwards;
}
.red-2-2 {
	animation-duration: calc(var(--anim-duration) / 1.5);
	animation-delay: calc(var(--anim-duration) / 3);
}
.red-3, .red-3-2 {
	top: 85px;
	left: 30px;
	opacity: 0;
	animation-name: red-3;
	animation-duration: var(--anim-duration);
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-fill-mode: forwards;
}
.red-3-2 {
	animation-delay: calc(var(--anim-duration) / 2);
}
.red-4, .red-4-2, .red-4-3 {
	top: 167px;
	left: 0px;
	opacity: 0;
	animation-name: red-4;
	animation-duration: calc(var(--anim-duration) + 0.5s);
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-fill-mode: forwards;
}
.red-4-2 {
	animation-delay: calc(var(--anim-duration) / 2);
}
.red-4-3 {
	animation-duration: calc(var(--anim-duration) / 1.5);
	animation-delay: calc(var(--anim-duration) / 2);
}

.blue-1, .blue-2, .blue-3, .blue-4, .blue-5, .blue-6, .blue-7 {
	--blue-anim-duration: calc(var(--anim-duration) / 1.2);
	top: 0px;
	left: 0px;
	opacity: 0;
	animation-name: blue-dots;
	animation-duration: var(--blue-anim-duration);
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-fill-mode: forwards;
}
.blue-1 {
	animation-delay: calc(var(--blue-anim-duration) + (var(--blue-anim-duration) / 7));
}
.blue-2 {
	animation-delay: calc(var(--blue-anim-duration) + (var(--blue-anim-duration) / 7 * 2));
}
.blue-3 {
	animation-delay: calc(var(--blue-anim-duration) + (var(--blue-anim-duration) / 7 * 3));
}
.blue-4 {
	animation-delay: calc(var(--blue-anim-duration) + (var(--blue-anim-duration) / 7 * 4));
}
.blue-5 {
	animation-delay: calc(var(--blue-anim-duration) + (var(--blue-anim-duration) / 7 * 5));
}
.blue-6 {
	animation-delay: calc(var(--blue-anim-duration) + (var(--blue-anim-duration) / 7 * 6));
}
.blue-7 {
	animation-delay: calc(var(--blue-anim-duration) + (var(--blue-anim-duration) / 7 * 7));
}

@keyframes blue-dots {
	5% {
		opacity: 0;
	}
	20% {
		opacity: 1;
	}
	80% {
		opacity: 1;
		left: 300px;
	}
	100% {
		opacity: 0;
		left: 400px;
	}
}

@keyframes red-1 {
	10% {
		opacity: 0.3;
	}
	60% {
		opacity: 1;
		top: 0px;
		left: 340px;
		transform: rotate(180deg);
	}
	70% {
		opacity: 1;
		top: 30px;
		left: 340px;
		transform: rotate(220deg);
	}
	90% {
		opacity: 1;
		top: 30px;
		left: 400px;
		transform: rotate(300deg);
	}
	100% {
		opacity: 0;
		top: 30px;
		left: 420px;
		transform: rotate(360deg);
	}
}
@keyframes red-2 {
	10% {
		opacity: 0.3;
	}
	90% {
		opacity: 1;
		left: 400px;
		transform: rotate(360deg);
	}
	100% {
		opacity: 0;
		left: 420px;
		transform: rotate(360deg);
	}
}
@keyframes red-3 {
	10% {
		opacity: 0.3;
	}
	45% {
		opacity: 1;
		top: 85px;
		left: 258px;
		transform: rotate(-270deg);
	}
	50% {
		opacity: 1;
		top: 98px;
		left: 258px;
		transform: rotate(-300deg);
	}
	90% {
		opacity: 1;
		top: 98px;
		left: 410px;
		transform: rotate(-680deg);
	}
	100% {
		opacity: 0;
		top: 98px;
		left: 420px;
		transform: rotate(-720deg);
	}
}
@keyframes red-4 {
	10% {
		opacity: 0.3;
	}
	65% {
		opacity: 1;
		top: 167px;
		left: 341px;
		transform: rotate(470deg);
	}
	75% {
		opacity: 1;
		top: 136px;
		left: 342px;
		transform: rotate(560deg);
	}
	90% {
		opacity: 1;
		top: 136px;
		left: 410px;
		transform: rotate(620deg);
	}
	100% {
		opacity: 0;
		top: 136px;
		left: 425px;
		transform: rotate(700deg);
	}
}
</style>